import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'my-norton-chart',
  templateUrl: './my-norton-chart.component.html',
})
export class MyNortonChartComponent {

  isStaff = this.store.state.isStaff;
  title = 'myNortonChart.title';
  progressBar = this.progress.myNortonChart;
  myNortonChart: boolean = this.store.state.consent.myNortonChart;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  back() {
    this.router.navigate([this.navigation.myNortonChart.back]);
  }

  next() {
    this.store.state.consent.myNortonChart = this.myNortonChart;
    this.router.navigate([this.navigation.myNortonChart.next]);
  }

}
